import React from 'react'

type Props = {
    title: string;
    backgroundImage: string;
    link: string;
}


const ExploreCard:React.FC<Props> = ({
    title,
    backgroundImage,
    link
}:Props) => {
    return (
        <div
            className="relative w-4/5 m:w-1/3 h-48 bg-cover bg-no-repeat bg-center mx:2 m:mx-10 my-4 cursor-pointer"
            style={{
                backgroundImage: `url(${backgroundImage})`,
            }}
        >
            <a href={link} target='_blank' rel='noreferrer'>
                <div className='absolute top-0 left-0 w-full h-full bg-black bg-opacity-20 hover:bg-opacity-40 flex justify-center items-center text-white text-shadow'>
                    <h3 className='text-3xl font-light'>{title}</h3>
                </div>
            </a>
        </div>
    )
}

export default ExploreCard
